import { withInstall } from "@xplus/utils/with-install";
import progress from "./src/progress.vue";
export const xProgress = withInstall(progress);
export default xProgress;
export * from "./src/progress";
